import { useState } from "react";

import { useConfigContext } from "shared/hooks";

import EndChatModal from "../EndChatModal";
import TopBarIFrame from "./TopBarIFrame";
import TopBarNonIframe from "./TopBarNonIframe";
import { Props } from "./types";

function TopBar(props: Props) {
  const {
    copyTexts,
    config,
    chatId,
    resetChat,
    messagesLength,
    messageLengthWhenSkipped,
    setMessageLengthWhenSkipped,
  } = props;
  const { isIframe } = useConfigContext();
  const [isEndChatModalOpen, setIsEndChatModalOpen] = useState(false);
  const [isCloseWidgetAfterEndChat, setIsCloseWidgetAfterEndChat] =
    useState(false);

  const TopBar = isIframe ? TopBarIFrame : TopBarNonIframe;

  return (
    <>
      <TopBar
        {...props}
        setIsResetChatModalOpen={setIsEndChatModalOpen}
        setIsEndChatModalOpen={setIsEndChatModalOpen}
        setIsCloseWidgetAfterEndChat={setIsCloseWidgetAfterEndChat}
      />
      {/* <ResetChatModal
        isResetChatModalOpen={isResetChatModalOpen}
        setIsResetChatModalOpen={setIsResetChatModalOpen}
        copyTexts={copyTexts}
        setIsEndChatModalOpen={setIsEndChatModalOpen}
        isIframe={isIframe}
        messagesLength={messagesLength}
      /> */}
      <EndChatModal
        isEndChatModalOpen={isEndChatModalOpen}
        setIsEndChatModalOpen={setIsEndChatModalOpen}
        resetChat={resetChat}
        copyTexts={copyTexts}
        config={config}
        chatId={chatId}
        isCloseWidgetAfterEndChat={isCloseWidgetAfterEndChat}
        messagesLength={messagesLength}
        messageLengthWhenSkipped={messageLengthWhenSkipped}
        setMessageLengthWhenSkipped={setMessageLengthWhenSkipped}
        isIframe={isIframe}
      />
    </>
  );
}
export default TopBar;
